/* eslint-disable react/prefer-es6-class, react/no-multi-comp */
import React from 'react';
import Localization from 'es6/services/localization';

/**
 * RadialProgress and RadialProgressSentence represent the circular
 * progress bars.
 *
 * It would be preferable to use clip or clip-path here, but since
 * clip is deprecated and clip-path is not fully supported yet, SVGs
 * are suitable.
 */

const Radius = 40;
const Circumference = 2 * Math.PI * Radius;
const StrokeWidth = 10;
const ViewBox = '0 0 100 100';

// For the sentence trainer radial progress. To adjust the arc length,
// change FromAngle to be the appropriate starting point for arc. It should
// end up in the third quadrant or the formulas will fall apart.
const FromAngle = (215 / 180) * Math.PI;
const ArcLength = Radius * (2 * Math.PI - 2 * (3 / 2 * Math.PI - FromAngle));
const ArcPathRX = 50 + (Math.cos(FromAngle) * Radius);
const ArcPathRY = 50 - (Math.sin(FromAngle) * Radius);
const ArcPath = `M${100 - ArcPathRX} ${ArcPathRY} A ${Radius} ${Radius} 0 1 0 ${ArcPathRX} ${ArcPathRY}`;

export const RadialProgress = React.createClass({
  displayName: 'RadialProgress',

  propTypes: {
    className: React.PropTypes.string,
    progress: React.PropTypes.number,
  },

  getDefaultProps() {
    return {
      className: '',
      progress: 0,
    };
  },

  render() {
    const className = `radial-progress ${this.props.className}`;
    const progress = this.props.progress;
    const strokeDasharray = `${Circumference * (progress / 100)} ${Circumference}`;

    return (
      <div className={className}>
        <svg className="svg" viewBox={ViewBox}>
          <circle r={Radius} cx="50" cy="50" strokeWidth={StrokeWidth} className="circle-fill" />
          <circle r={Radius} cx="50" cy="50" transform="rotate(-90 50 50)" strokeWidth={StrokeWidth} strokeDasharray={strokeDasharray} className="circle-meter" />
        </svg>

        <div className="progress-tag">
          <span className="progress">{progress}</span>
          <span className="percent">%</span>
        </div>
      </div>
    );
  },
});

/**
 * This progress bar works a little differently. Because the style
 * uses a gradient, the meter path is shown in full, then hidden by
 * an overlapping fill path.
 */
export const RadialProgressSentenceTrainer = React.createClass({
  displayName: 'RadialProgressSentenceTrainer',

  propTypes: {
    className: React.PropTypes.string,
    level: React.PropTypes.number,
    progress: React.PropTypes.number,
  },

  getDefaultProps() {
    return {
      className: '',
      level: 0,
      progress: 0,
    };
  },

  render() {
    const className = `radial-progress radial-progress-sentence-trainer ${this.props.className}`;
    const remainingProgress = 100 - this.props.progress;
    const strokeDasharray = `${ArcLength * (remainingProgress / 100)} ${ArcLength}`;

    return (
      <div className={className}>
        <svg className="svg" viewBox={ViewBox}>
          <defs>
            <linearGradient id="progress-gradient">
              <stop offset="0%" className="stop1" />
              <stop offset="33%" className="stop2" />
              <stop offset="66%" className="stop2" />
              <stop offset="100%" className="stop3" />
            </linearGradient>
          </defs>
          <path d={ArcPath} strokeWidth={StrokeWidth} className="arc-meter" />
          <path d={ArcPath} strokeWidth={StrokeWidth} strokeDasharray={strokeDasharray} className="arc-fill" />
        </svg>

        <span className="level">{this.props.level}</span>
        <span className="level-label">{Localization.t('radial-progress.level')}</span>
      </div>
    );
  },
});

export default RadialProgress;
